import type { Translator, Vars } from '@porotutu/i18n'

export type ApiError = { status: number; value: unknown }

type Detail = { path?: string; message?: string; vars?: Vars }

export function fieldErrors(error: ApiError | null, t?: Translator): Record<string, string> {
  if (error?.status !== 422) return {}

  const detail = (error.value as { detail?: unknown })?.detail

  if (!Array.isArray(detail)) return {}

  const errors: Record<string, string> = {}

  for (const entry of detail as Detail[]) {
    const path = String(entry.path ?? '').replace(/^\//, '')
    const message = String(entry.message ?? 'invalid')

    if (path && !errors[path]) {
      errors[path] = t === undefined ? message : t(message, entry.vars ?? {})
    }
  }

  return errors
}
